export const RoutesPath = {
  HOME: "/",
  USER: "/users",
  USER_EDIT: "/users/edit/",
  USER_VIEW: "/users/view/",
  EVENT: "/event",
  EVENT_EDIT: "/event/edit/",
  EVENT_VIEW: "/event/view/",
  REPORT_ISSUE: "/report-issue",
  REPORT_ISSUE_EDIT: "/report-issue/edit/",
  REPORT_ISSUE_VIEW: "/report-issue/view/",
  GALLERY: "/gallery",
  GALLERY_EDIT: "/gallery/edit/",
  GALLERY_VIEW: "/gallery/view/",
  LOGIN: "/login",
};
